<div id="intro">
  <figure class="hero hero--has-caption-right">
    <picture class="hero__picture">
      <img title="" width="" height="" fetchpriority="high" class="hero__image" alt="{{ alt }}" src="{{ image }}" />
    </picture>
  </figure>
  <div class="filters">
    <div class="container">
      <div class="location-search-hero__caption">
        <h1 class="title title--1 title--bold u-mb--4">{{ title }}</h1>
        <div class="subtitleAndAction">
          <div class="subtitleContainer">
            <span *ngIf="subTitle" class="area">{{ subTitle }}</span>

            <div class="controlWrapper" *ngIf="versions.length > 1">
              <div class="customSelect">
                <select [(ngModel)]="version" (change)="onVersionChange($event)">
                  <option *ngFor="let versionItem of versions" [value]="versionItem.version">
                    {{ 'Versión' + versionItem.version }}
                  </option>
                </select>
              </div>
            </div>

            <div class="version" *ngIf="version">Versión: {{ version }}</div>

            <span *ngIf="status" class="tag" [ngClass]="getStatusClass()">{{
              getStatusText()
              }}</span>
          </div>
          <button *ngIf="buttonText" (click)="buttonAction.emit()" class="secondary">
            {{ buttonText }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
